import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { useTranslation } from 'react-i18next';
const Main = ({ appKey }) => {
  const prefix = `${appKey}_`;
  const { t } = useTranslation();

  return (
    <>
      <Header appKey={appKey} />
      <div className="container">
        <h3 className="mt-5 pt-5 text-center" style={{ height: '600px' }}>{t(prefix)}</h3>
      </div>
      <Footer appKey={appKey} />
    </>
  )
}

export default Main
